import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";
import hometrackStillPreviewSrc1 from "public/addons/hometrack/hometrack-still-preview-1.jpg";
import hometrackStillPreviewSrc2 from "public/addons/hometrack/hometrack-still-preview-2.jpg";

import { AddOnPromotionPage } from "../components/AddOnPromotionPage";
import { hometrackPrimaryActionHandler } from "../addOnActionHandlers";
import { HOMETRACK_ADDON } from "../constants";

export const HometrackPage = () => {
  const hasZooplaAddon = hasFeature(Feature.zooplaFullAccess);

  return (
    <AddOnPromotionPage
      {...HOMETRACK_ADDON}
      videoId="HygyNgy-HVM"
      videoTitle="Property appraisal comparables powered by LandTech and Hometrack"
      previewImages={[
        { src: hometrackStillPreviewSrc1, alt: "Preview" },
        { src: hometrackStillPreviewSrc2, alt: "Preview" },
      ]}
      onPrimaryActionClick={hometrackPrimaryActionHandler}
      primaryActionText={hasZooplaAddon ? "Added" : "Contact"}
      primaryActionDisabled={hasZooplaAddon}
    />
  );
};
